export default __webpack_public_path__ + "assets/bce34f10016cd23b67100d9133458b3d.jpg";